export default class {
	constructor(obj) {
		this.id = obj.id
		this.title = obj.name
		this.creationDate = obj.creation_date
		this.updateDate = obj.update_date
		this.lastExecution = obj.last_execution
		this.state = obj.selectionstatus_id
		this.close = obj.close
		this.closeDate = obj.closedate
		this.favorite = obj.favorite
		this.role = obj.role
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoSelection.js